export enum TrafficSituationSeverity {
  slight = 'slight',
  normal = 'normal',
  severe = 'severe',
}
